import React from 'react';
import BaseTemplate from './base.js';
import Details from './details.js';
import {ImageElement,RatingElement,ContentElement} from './elements.js';
import * as u from '../utils.js'
import chroma from 'chroma-js';

/*---------------------------------------------*/

const MOBILE_STYLE = {
	container: {
		paddingTop: 25,
		paddingBottom: 18,
		paddingLeft: 24,
		paddingRight: 24
	},
	spacing: {
		top: 11,
		bottom: 15
	},
	content: {
		lineHeight: 1.5
	}
}

const BREAKPOINTS_STYLES = {
	280: {
		container: {
			paddingTop: 25,
			paddingBottom: 18,
			paddingLeft: 24,
			paddingRight: 24
		},
		spacing: {
			top: 11,
			bottom: 15
		},
		content: {
			lineHeight: 1.5
		}
	},
	360: {
		container: {
			paddingTop: 33,
			paddingBottom: 22,
			paddingLeft: 32,
			paddingRight: 32
		},
		spacing: {
			top: 11,
			bottom: 15
		},
		content: {
			lineHeight: 1.5
		}
	},
	440: {
		container: {
			paddingTop: 37,
			paddingBottom: 30,
			paddingLeft: 40,
			paddingRight: 40
		},
		spacing: {
			top: 15,
			bottom: 23
		},
		content: {
			lineHeight: 1.5
		}
	},
	Infinity: {
		container: {
			paddingTop: 41,
			paddingBottom: 34,
			paddingLeft: 48,
			paddingRight: 48
		},
		spacing: {
			top: 15,
			bottom: 23
		},
		content: {
			lineHeight: 1.75
		}
	}
}

/*---------------------------------------------*/

class CloseButton extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
				<g fill="none" fillRule="evenodd">
					<path d="M0 0h16v16H0z"/>
					<path fill={this.props.color} fillRule="nonzero" d="M4.173 2.944l8.495 8.863a.5.5 0 0 1 0 .692l-.12.124a.5.5 0 0 1-.721 0L3.332 3.761a.5.5 0 0 1 0-.692l.12-.125a.5.5 0 0 1 .721 0z"/>
					<path fill={this.props.color} fillRule="nonzero" d="M11.827 2.944l-8.495 8.863a.5.5 0 0 0 0 .692l.12.124a.5.5 0 0 0 .721 0l8.495-8.862a.5.5 0 0 0 0-.692l-.12-.125a.5.5 0 0 0-.721 0z"/>
				</g>
			</svg>
		)
	}
}

/*---------------------------------------------*/

class CardDetails extends BaseTemplate {
	constructor() {
		super();
		this.state = {
			...this.state,
			contentHeight: 0
		};

		this.contentRef = React.createRef();
		this.ratingRef = React.createRef();
		
		this.checkSize = this.checkSize.bind(this);
	}

	checkSize() {
		let contentHeight = 
			(this.contentRef && this.contentRef.current && this.contentRef.current.offsetHeight) -
			(this.ratingRef && this.ratingRef.current && this.ratingRef.current.offsetHeight);

		if (contentHeight !== this.state.contentHeight)
			this.setState({contentHeight: contentHeight});
	}

	getComposition() {
		let textPosition = this.context.get('template.textposition');
		let composition = (textPosition === 'top') ? ['content','details'] : ['details','content'];
		
		let ratingEnabled = this.context.get('fields.rating.enabled');
		if (ratingEnabled && this.props.data.rating) {
			let contenPosition = composition.indexOf('content');
			let ratingPosition = this.context.get('template.ratingposition2');
			if (ratingPosition === 'above') {
				composition.splice(contenPosition,0,"rating");
			} else {
				composition.splice(contenPosition+1,0,"rating");
			}
		}

		composition.splice((textPosition === 'top') ? 0 : composition.length, 0, 'date');
		return composition.join('-');
	}

	render() {
		let data = this.props.data;
		let alignment = this.context.get('template.card.alignment','left');
		let responsiveStyle = this.context.isMobile() ? MOBILE_STYLE : u.getBreakpointStyle(BREAKPOINTS_STYLES,this.props.width);

		let styles = {
			container: {
				...this.props.baseStyle,
				...responsiveStyle.container,
			
				boxSizing: 'border-box',
				width: '100%',
				height: '100%',
				
				display: 'inline-grid',
				gridTemplateRows: ''
			},
			content: {
				gridColumn: 1,
				overflow: 'hidden',
				position: 'relative'
			},
			contentText: {
				...responsiveStyle.content,
				position: 'relative'
			},
			details: {
				gridColumn: 1
			},
			date: {
			},
			rating: {
				gridColumn: 1,
				fontSize: 1*this.context.get('ratingFontSize',16)
			}
		}

		if (this.context.get('style.lineHeight')) {
			styles.content.lineHeight = this.context.get('style.lineHeight');
		}
		
		let composition = this.getComposition();
		if (this.props.fullscreen && this.context.get('template.card.overlay.textOnly')) {
			composition = composition.replace('details-','').replace('-details','');
			composition = composition.replace('date-','').replace('-date','');
		}

		switch (composition) {
			case 'details-rating-content-date':
				styles.details.marginBottom = responsiveStyle.spacing.top;
				styles.date.marginTop = responsiveStyle.spacing.bottom;
				styles.rating.paddingBottom = 5;
				break;

			case 'details-content-date':
			case 'details-content-rating-date':
				styles.details.marginBottom = responsiveStyle.spacing.top;
				styles.date.marginTop = responsiveStyle.spacing.bottom;
				styles.rating.paddingTop = 5;
				break;

			case 'date-rating-content-details':
				styles.date.marginBottom = responsiveStyle.spacing.top;
				styles.details.marginTop = responsiveStyle.spacing.bottom;
				styles.rating.paddingBottom = 5;
				break;

			case 'date-content-details':
			case 'date-content-rating-details':
				styles.date.marginBottom = responsiveStyle.spacing.top;
				styles.details.marginTop = responsiveStyle.spacing.bottom;
				styles.rating.paddingTop = 5;
				break;
		}

		let contentDisplay = (this.props.fullscreen ? 'scroll' : 'line-fit');
		let components = {
			content: <ContentElement text={data.text} display={contentDisplay} height={this.state.contentHeight} onExpand={this.props.onExpand} baseStyle={styles.contentText} key='content' />,
			date: <div style={styles.date} key='date'><Details data={data} alignment={alignment} elements='date' /></div>,
			details: <div style={styles.details} key='details'><Details data={data} elements='name,job_title' /></div>,
			rating: <div style={styles.rating} key='rating'><RatingElement rating={data.rating} /></div>
		}

		let ratingPosition = this.context.get('template.ratingposition2');
		if (ratingPosition !== 'above') {
			// if the rating is on the bottom we need it to have a ref to adjust for its height
			components.content = (
				<div style={styles.content} ref={this.contentRef} key='content'>
					{components.content}
					{data.rating && <div style={styles.rating} ref={this.ratingRef}><RatingElement rating={data.rating} key='rating' /></div>}
				</div>
			)

			components.rating = null;

		} else {
			components.content = (
				<div style={styles.content} ref={this.contentRef} key='content'>
					{components.content}
				</div>
			)
		}

		let compositionParts = composition.split('-');
		compositionParts.forEach((type,index) => {
			styles[type] = styles[type] || {};
			styles[type].gridRow = index+1;
			// styles[type].paddingTop = index > 0 ? 4 : 0;
			// styles[type].paddingBottom = index < compositionParts.length-1 ? 4 : 0;
		});

		let textContent = compositionParts.map((type) => components[type]);

		let gridTemplateRows = {content: '1fr', date: 'auto', details: 'auto', rating: 'auto'};
		styles.container.gridTemplateRows = compositionParts.map((type) => gridTemplateRows[type]).join(' ');

		setTimeout(() => this.checkSize());

		return (
			<div style={styles.container} key='details'>
				{textContent}
			</div>
		)
	}
}

/*---------------------------------------------*/

export default class CardTemplate extends BaseTemplate {
	constructor() {
		super();
		this.state = {
			...this.state,
			expanded: false
		};

		this.onExpand = this.onExpand.bind(this);
		this.onClose = this.onClose.bind(this);
	}

	componentDidMount() {
		window.inffuse.on("open-card-overlay",() => {
			this.onExpand();
		});

		window.inffuse.on("close-card-overlay",() => {
			this.onClose();
		});
	}

	onExpand() {
		this.setState({expanded: true});
	}

	onClose() {
		this.setState({expanded: false});
	}

	render() {
		let data = this.props.data;

		// let isCompact = this.context.isMobile() || (this.props.width < 400);
		let imageEnabled = this.context.get('fields.image.enabled',true);
		let imagePosition = imageEnabled ? this.context.get('template.card.imageposition','left') : 'none';
		let alignment = this.context.get('template.card.alignment','left');
		
		let styles = {
			container: {
				...this.props.baseStyle,
				textAlign: alignment,
				position: 'relative',
				width: '100%'
			},
			image: {
				display: 'inline-block',
				position: 'absolute'
			},
			imageInner: {
				display: 'inline-block',
				position: 'absolute',
				height: '100%',
				width: '100%',
				left: 0,
				top: 0
			},
			close: {
				position: 'absolute',
				top: 10,
				right: 10,
				cursor: 'pointer',

			},
			contentWithDetails: {
				position: 'absolute',
				boxSizing: 'border-box'
			}
		}

		styles.overlayContainer = {
			position: 'absolute',
			left: 0,
			top: 0,
			right: 0,
			bottom: 0,
			background: 'rgba(255,255,255,0.5)'
		}

		let overlayMargin = this.context.get('template.card.overlay.margin',24);
		styles.overlay = {
			...styles.contentWithDetails,
			left: overlayMargin,
			top: overlayMargin,
			right: overlayMargin,
			bottom: overlayMargin,
			background: chroma(styles.container.background).alpha(1),
			boxShadow: '0 0 10px 1px rgba(0, 0, 0, 0.35)'
		}

		// the bother radius of the overlay should be proportionally smaller relative to the template border radius
		let containerSize = this.container && this.container.current && Math.min(this.container.current.offsetHeight,this.container.current.offsetWidth);
		styles.overlay.borderRadius = this.context.get('style.testimonial.border.radius',0) * (containerSize-overlayMargin*2) / containerSize;

		switch (imagePosition) {
			case 'none':
				styles.container.paddingBottom = '100%';
				styles.image.display = 'none';
				
				styles.contentWithDetails.width = '100%';
				styles.contentWithDetails.height = '100%';
				styles.contentWithDetails.top = 0;
				styles.contentWithDetails.right = 0;
				break;

			case 'left':
			case 'right':
				styles.container.paddingBottom = '50%';
				styles.image.height = '100%';
				styles.image.width = '50%';
				styles.image[imagePosition] = 0;
				
				styles.contentWithDetails.width = '50%';
				styles.contentWithDetails.height = '100%';
				styles.contentWithDetails[imagePosition === 'left' ? 'right' : 'left'] = 0;
				break;
			
			case 'top':
			case 'bottom':
				styles.container.paddingBottom = '200%';
				styles.image.height = '50%';
				styles.image.width = '100%';
				styles.image.left = 0;
				styles.image[imagePosition] = 0;
				
				styles.contentWithDetails.height = '50%';
				styles.contentWithDetails.width = '100%';
				styles.contentWithDetails.left = 0;
				styles.contentWithDetails[imagePosition === 'top' ? 'bottom' : 'top'] = 0;
				break;
			
			default:
				break;
		}

		let textColor = u.renderColor(this.context.get('style.text.color'));
		let overlay = this.state.expanded && (
			<div style={styles.overlayContainer} key='overlay'>
				<div style={styles.overlay}>
					<CardDetails data={this.props.data} width={this.props.width} fullscreen={true}></CardDetails>
					<div style={styles.close} onClick={this.onClose} alt='Close'>
						<CloseButton color={textColor}></CloseButton>
					</div>
				</div>
			</div>
		);

		let detailsWidth = this.props.width * (styles.image.width.replace('%','')/100);
		return (
			<div className="testimonial" style={styles.container} ref={this.container}>
				<div style={styles.image}>
					<ImageElement image={data.author_image} size="100%" radius="0" noborder={true} baseStyle={styles.imageInner} key='image' />
				</div>
				<div style={styles.contentWithDetails} key='details'>
					<CardDetails data={this.props.data} width={detailsWidth} onExpand={this.onExpand}></CardDetails>
				</div>
				{overlay}
			</div>
		)
	}
}

/*---------------------------------------------*/
